module.exports = __webpack_public_path__ + "img/house2.7e3c493a.png";